import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Lisa K.",
      location: "Kentwood, MI",
      service: "Housekeeping Organization Systems",
      rating: 5,
      text: "The housekeeping systems they created changed our family's daily routine completely. Our home stays organized with minimal effort now!",
    },
    {
      name: "Jennifer T.",
      location: "East Grand Rapids, MI",
      service: "Real Estate Prep & Staging",
      rating: 5,
      text: "Our house sold in just 12 days thanks to their real estate prep work. They transformed cluttered spaces into showroom-ready rooms!",
    },
    {
      name: "Mark D.",
      location: "Grand Rapids, MI",
      service: "ADHD Organization Systems",
      rating: 5,
      text: "Finally, organization systems that work with my ADHD brain! Everything has a logical place and the visual cues make maintenance so much easier.",
    },
    {
      name: "Amy R.",
      location: "Brighton, MI", 
      service: "Same-Day Emergency Service",
      rating: 5,
      text: "They transformed our entire main floor in one day before my in-laws arrived. Professional, fast, and the results were absolutely stunning!",
    },
  ];

  return (
    <section id="testimonials" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-light mb-6">
            What Our Clients Say
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Real transformations from Michigan families who love their organized homes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-border bg-background hover:shadow-lg transition-all duration-300">
              <CardContent className="p-8">
                <div className="flex items-center mb-4">
                  <Quote className="w-8 h-8 text-primary/30 mr-4" />
                  <div className="flex space-x-1">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                    ))}
                  </div>
                </div>
                
                <blockquote className="text-foreground mb-6 leading-relaxed">
                  "{testimonial.text}"
                </blockquote>
                
                <div className="border-t border-border pt-4">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="font-semibold text-foreground">{testimonial.name}</p>
                      <p className="text-sm text-muted-foreground">{testimonial.location}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-sm font-medium text-primary">{testimonial.service}</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center space-x-8 text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Star className="w-5 h-5 fill-primary text-primary" />
              <span className="font-medium">5.0 Average Rating</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-medium">200+ Michigan Homes Transformed</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="font-medium">10+ Years Experience</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;